var render = function render(){var _vm=this,_c=_vm._self._c;return _c('btn',_vm._g(_vm._b({attrs:{"link":"","href":_vm.hrefValue,"icon":_vm.icon,"iconset":_vm.iconset}},'btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }